import { get, put, post, del } from '../../../api';

export const getTemplates = (idGrupo) => {
  return get(`/api/conectores/templates/grupo/${idGrupo}`);
};

export const getTemplate = (id) => {
  return get(`/api/conectores/template/${id}`);
};

export const getTemplateConectores = (id) => {
  return get(`/api/conectores/template/conectores/${id}`);
};

export const postTemplate = (data) => {
  return post('/api/conectores/template', data);
};

export const putTemplate = (data) => {
  return put('/api/conectores/template', data);
};

export const deleteTemplateConector = (idConfiguracao, idFonteDado) => {
  return del(`/api/conectores/template/conector/${idConfiguracao}/${idFonteDado}`);
};

export const getTemplatesGrupos = async () => {
  const res = await get('/api/conectores/templates/grupos');

  return res.map((item) => ({
    key: item.id,
    value: item.id,
    title: `${item.dsGrupo} - ${item.dsTemplate}`,
  }));
};
